import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const orderByDescendingAsync = (source, keySelector, comparer) => {
    return OrderedEnumerable.generateAsync(source, keySelector, false, comparer);
};
